import { Component, Input, Output, OnInit, EventEmitter, ViewChild, ElementRef, ViewEncapsulation } from '@angular/core';

import { TreeSelectionModel } from './tree-selection.model';
import { FilterItemsService } from './filter-items.service';
import { MediationFilters } from "../mediation/mediation.filters";
import { consts } from "./consts";
import { StorageService } from "../core/services/index";

@Component({
    selector: 'providers-tree-selection-modal',
    templateUrl: 'providers-tree-selection-modal.component.html',
    encapsulation: ViewEncapsulation.None
})
export class ProviderTreeSelectionModalComponent implements OnInit {
    values: Array<TreeSelectionModel> = new Array<TreeSelectionModel>();
    itemsSelectedCount: number = 0;

    @Output()
    valueChange: EventEmitter<Array<number>> = new EventEmitter<Array<number>>();;

    constructor(
        private storageService: StorageService,
        private filterItemsService: FilterItemsService) {
        this.values = this.values || new Array<TreeSelectionModel>();
    }

    ngOnInit() {
        this.values = this.filterItemsService.getProvidersTreeViewModel();
        let providerFromStorage = this.storageService.get(consts.ProviderIdsFilterStorageKey);
        let mediationFilter = <MediationFilters>this.storageService.get(consts.MediationFilterStorageKey);
        if (providerFromStorage || mediationFilter) {
            if (providerFromStorage) {
                let items = <Array<Number>>providerFromStorage;
                this.values.forEach(s => s.isSelected = null);
                let _values = this.values.filter(s => items.indexOf(s.value) > -1);
                _values.forEach(s => s.isSelected = true);
            }
            if (mediationFilter != null && mediationFilter.providerId != null) {
                this.values.forEach(s => s.isSelected = null);
                let item = this.values.find(s => s.value === mediationFilter.providerId);
                item.isSelected = true;
            }
        }
        this.itemsSelectedCount = $("#providers-select").next().find("[class='selected']").find("[class='item']").length;
        setInterval(() => {
            this.itemsSelectedCount = $("#providers-select").next().find("[class='selected']").find("[class='item']").length;
        }, 300);
    }

    onApplyFilter(event) {
        let items = $("#providers-select").next().find("[class='selected']").find("[class='item']");
        let result = Array<number>();
        if (items)
            for (var i = 0; i < items.length; i++) {
                result.push($(items[i]).data("value"));
            }

        if (result.length !== 0) {
            $('#treeProvidersFilter').modal('hide');
            this.valueChange.emit(result);
        }
    }

    resetSelection() {
        $("#providers-select").next().find("[class='select-all-container']").find("span:first").click();
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/providers-tree-selection-modal.component.ts